
/* blog faq js */
document.addEventListener("click", function (e) {

    var h3 = e.target.closest(".bloag_news_faq h3");

    if (!h3) return;

    var faq = h3.parentElement;
    var answer = faq.querySelector(".bloag_news_faq_answer");

    if (!answer) return;

    var allFaqs = document.querySelectorAll(".bloag_news_faq");

    allFaqs.forEach(function (item) {

        if (item !== faq) {
            item.classList.remove("active");

            var itemAnswer = item.querySelector(".bloag_news_faq_answer");

            if (itemAnswer) {
                itemAnswer.style.display = "none";
            }
        }

    });

    if (faq.classList.contains("active")) {

        faq.classList.remove("active");
        answer.style.display = "none";

    } else {

        faq.classList.add("active");
        answer.style.display = "block";

    }

});